import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function TermsPage() {
  usePageMeta(
    "Termeni și Condiții - Ordell WebCare",
    "Termenii și condițiile de utilizare a serviciilor Ordell WebCare, operat de SC Maze Digital SRL."
  );

  return (
    <section data-testid="terms-page" className="py-16 lg:py-24">
      <div className="section-container max-w-3xl">
        <h1 className="font-['Outfit'] text-4xl sm:text-5xl tracking-tighter leading-none font-bold text-[#1A1D20] mb-8">
          Termeni și condiții
        </h1>
        <p className="text-xs text-[#64748B] mb-8">Ultima actualizare: Decembrie 2025</p>

        <div className="prose prose-sm max-w-none space-y-6 text-[#4A5568] leading-relaxed">
          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20]">1. Informații generale</h2>
          <p>
            Prezentii termeni și condiții reglementează utilizarea site-ului web Ordell WebCare și a serviciilor oferite de SC Maze Digital SRL, CUI: RO38272886, cu sediul social în România.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">2. Servicii</h2>
          <p>
            Ordell WebCare oferă servicii de mentenanță și suport WordPress, incluzând dar nelimitându-se la: actualizări WordPress, monitorizare uptime, verificări de securitate, backup și restaurare, suport tehnic și intervenții. Detaliile specifice ale fiecărui plan sunt descrise pe pagina Pachete.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">3. Contractarea serviciilor</h2>
          <p>
            Serviciile sunt contractate pe baza unui acord scris (contract sau comandă fermă) între SC Maze Digital SRL și client. Prețurile afișate pe site sunt orientative și pot fi ajustate în funcție de complexitatea proiectului.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">4. Plata</h2>
          <p>
            Plata se efectuează lunar, în avans, conform termenilor stabiliți în contract. Prețurile sunt exprimate în lei (RON) și nu includ TVA, dacă nu se specifică altfel.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">5. Obligațiile clientului</h2>
          <p>
            Clientul se obligă să furnizeze accesurile necesare pentru prestarea serviciilor, să comunice prompt orice problemă sau modificare relevantă și să respecte termenii de plată agreați.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">6. Limitarea răspunderii</h2>
          <p>
            SC Maze Digital SRL depune eforturi rezonabile pentru a asigura funcționarea corectă a site-urilor aflate în mentenanță. Nu garantăm disponibilitate 100% și nu răspundem pentru pierderi cauzate de factori aflați în afara controlului nostru (furnizori de hosting, atacuri cibernetice, erori ale pluginurilor terțe).
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">7. Încetarea colaborării</h2>
          <p>
            Oricare dintre părți poate înceta colaborarea cu un preaviz de 30 de zile. La încetarea contractului, toate accesurile sunt restituite clientului.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">8. Proprietate intelectuala</h2>
          <p>
            Conținutul site-ului Ordell WebCare (texte, design, structură) este proprietatea SC Maze Digital SRL și este protejat de legislația privind drepturile de autor.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">9. Legea aplicabila</h2>
          <p>
            Prezentii termeni sunt guvernați de legislația română. Orice litigiu va fi soluționat pe cale amiabilă sau, în caz contrar, de instanța competentă din România.
          </p>

          <p className="text-sm !mt-8"><strong>Operator:</strong> SC Maze Digital SRL, CUI: RO38272886</p>
        </div>

        <div className="mt-12">
          <Link to="/" className="text-sm font-medium text-[#0F2942] hover:text-[#0F2942]/80 transition-colors">
            &larr; Înapoi la pagina principală
          </Link>
        </div>
      </div>
    </section>
  );
}
